import { SUITE } from "../../common/apiUrl/suite/suiteUrls";
import { API } from "../../common/model/objectTypes";
import { userManagementInfo } from "../../utils/apiDescription/suite/userManagement";
import { API_BASE_URL } from "../../utils/constants";
import { commonRequestHeader, commonResponseBody, createCommonJsonResponseWithData } from "../../utils/objectTypeConstants";
import { addUserRequestBody, deleteUserRequestParameter, editUserRequestBody, getAllUserGroupsResponseBody, getAllUsersRequestParameter, getAllUsersResponseBody } from "../../utils/suite/apiObjects";
import { addUserRequestCurl, deleteUserJsonRequestCurl, editUserRequestCurl, getAllUserGroupsRequestCurl, getAllUsersJsonRequestCurl } from "../../utils/suite/sampleJsonRequest";
import { getAllUserGroupsJsonResponse, getAllUsersJsonResponse } from "../../utils/suite/sampleJsonResponse";

const AddUser: API = {
    name: "Add User",
    url: `${API_BASE_URL}/${SUITE.USER_MANAGEMENT.ADD_USER_URL}`,
    method: "POST",
    headers: commonRequestHeader,
    apiInfo: userManagementInfo.addUser,
    requestBody: addUserRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: addUserRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(200),
}

const All: API = {
    name: "All Users",
    url: `${API_BASE_URL}/${SUITE.USER_MANAGEMENT.GET_ALL_USERS_URL}`,
    method: "GET",
    headers: commonRequestHeader,
    apiInfo: userManagementInfo.getAllUsers,
    requestBody: getAllUsersRequestParameter,
    responseBody: getAllUsersResponseBody,
    jsonRequest: getAllUsersJsonRequestCurl,
    jsonResponse: getAllUsersJsonResponse,
}

const GetAllUserGroups: API = {
    name: "All User Groups",
    url: `${API_BASE_URL}/${SUITE.USER_MANAGEMENT.GET_ALL_USER_GROUPS_URL}`,
    method: "GET",
    headers: commonRequestHeader,
    apiInfo: userManagementInfo.getAllUserGroups,
    responseBody: getAllUserGroupsResponseBody,
    jsonRequest: getAllUserGroupsRequestCurl,
    jsonResponse: getAllUserGroupsJsonResponse,
}

const EditUser: API = {
    name: "Edit User",
    url: `${API_BASE_URL}/${SUITE.USER_MANAGEMENT.EDIT_USER_URL}`,
    method: "PUT",
    headers: commonRequestHeader,
    apiInfo: userManagementInfo.editUser,
    requestBody: editUserRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: editUserRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(200),
}

const DeleteUser: API = {
    name: "Delete User",
    url: `${API_BASE_URL}/${SUITE.USER_MANAGEMENT.DELETE_USER_URL}`,
    method: "DEL",
    headers: commonRequestHeader,
    apiInfo: userManagementInfo.deleteUser,
    requestBody: deleteUserRequestParameter,
    responseBody: commonResponseBody,
    jsonRequest: deleteUserJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(200),
}

export const getContent = (apiName: string) => {
    switch (apiName) {
        case 'All':
            return All;
        case 'Add User':
            return AddUser;
        case 'All User Groups':
            return GetAllUserGroups;
        case 'Edit User':
            return EditUser;
        case 'Delete User':
            return DeleteUser;
    }
}